import { IOption } from "@/types"
import { clsx } from "clsx"
import "./style.sass"

interface Props extends Omit<React.HTMLAttributes<HTMLDivElement>, "onChange"> {
  mode?: "light" | "dark"
  items: IOption[]
  onChange: (option: IOption) => void
  value?: string | number
}

export const ButtonTabs = ({ mode = "light", items, onChange, value, ...rest }: Props) => {
  return (
    <div {...rest} className={clsx("button-tabs", rest.className)}>
      {items.map((item) => (
        <button
          key={item.value}
          className={clsx(`button-tabs__${mode} button-tabs__item`, {
            [`button-tabs__${mode}--active`]: value === item.value,
          })}
          data-value={item.value}
          onClick={() => onChange(item)}
        >
          {item.label}
        </button>
      ))}
    </div>
  )
}
